const initiatePaymentUrl = (orderId: string) => `/payments/orderOverview/index.html?orderId=${orderId}`;
const proPricesUrl = 'https://www.marktplaatszakelijk.nl/ondernemersportaal/pro/tarieven/';

export { initiatePaymentUrl, proPricesUrl };
